import { render, staticRenderFns } from "./BindingDeviceHome.vue?vue&type=template&id=2ad239bf&"
import script from "./BindingDeviceHome.vue?vue&type=script&lang=js&"
export * from "./BindingDeviceHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports